import { render, staticRenderFns } from "./TraspasosImport.vue?vue&type=template&id=9ff23d14&"
import script from "./TraspasosImport.vue?vue&type=script&lang=js&"
export * from "./TraspasosImport.vue?vue&type=script&lang=js&"
import style0 from "./TraspasosImport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports